import { useEffect, useState } from 'react';
import InputField from '../../../../../components/molecules/InputField';
import InputFieldSelect from '../../../../../components/molecules/InputField/InputFieldSelect';
import InputFieldSwitch from '../../../../../components/molecules/InputField/InputFieldSwitch';
import { updateObject } from '../../../../../helpers/obj';
import NodeUpdates from './NodeUpdates';

const NodeEdges = ({ config, onChange }) => {
    const [edges, setEdges] = useState(config);
    const [selectedRow, setSelectedRow] = useState(0);
    const handleDelete = () => {};

    const handleUpdate = (index, values) => {
        const newEdges = [...edges];
        Object.entries(values).forEach(([key, value]) => {
            newEdges[index] = updateObject(newEdges[index], key, value);
        });
        updateEdges(newEdges);
    };

    const handleAdd = () => {
        const newEdges = [...edges];
        newEdges.push({
            action: '',
            target_node: '',
        });
        updateEdges(newEdges);
    };

    const updateEdges = (newEdges) => {
        setEdges(newEdges);
        if (onChange) {
            onChange(newEdges);
        }
    };

    useEffect(() => {
        if (config) {
            setEdges(config);
        }
    }, [config]);
    return (
        <>
            {edges?.map((row, index) => {
                return (
                    <div
                        className='panel__section p-5'
                        key={index}>
                        <div className='d-flex align-items-center justify-content-between'>
                            <div className='d-flex align-items-center'>
                                <i
                                    className={`bi bi-sign-turn-right-fill me-1 ${
                                        selectedRow === index ? 'text-success' : ''
                                    }`}></i>
                                <h5
                                    onClick={() =>
                                        selectedRow === index
                                            ? setSelectedRow('')
                                            : setSelectedRow(index)
                                    }
                                    className='fs-8 p-0 m-0 cursor-pointer'>
                                    {typeof row?.target_node === 'string'
                                        ? row?.target_node
                                        : `Edge ${index + 1}`}
                                </h5>
                            </div>
                            <div>
                                <span
                                    className='cursor-pointer ms-2'
                                    onClick={() => handleDelete(index)}>
                                    <i className='bi bi-dash-circle-fill text-danger'></i>
                                </span>
                                <span
                                    className='cursor-pointer ms-2'
                                    onClick={() => setSelectedRow(index)}>
                                    <i
                                        className={`bi bi-chevron-${
                                            selectedRow === index ? 'up' : 'down'
                                        }`}></i>
                                </span>
                            </div>
                        </div>
                        {selectedRow === index && (
                            <div className='my-3'>
                                <h5 className='fs-8'>Action</h5>
                                <InputFieldSelect
                                    config={{
                                        name: 'action',
                                        options: [
                                            { value: 'submit', label: 'Submit' },
                                            { value: 'api_request', label: 'API Request' },
                                            { value: 'edge_operation', label: 'Edge Operation' },
                                            { value: 'expression', label: 'Expression' },
                                            { value: 'flow_connector', label: 'Flow Connector' },
                                            { value: 'task', label: 'Task' },
                                            { value: 'auto', label: 'Auto' },
                                        ],
                                    }}
                                    defaultValue={row?.action}
                                    onChange={(value) => handleUpdate(index, { action: value })}
                                    className='form-select-xs w-100px'
                                />

                                <h5 className='fs-8 my-3'>Update Store</h5>
                                <NodeUpdates config={row?.update_store?.templates} />

                                <h5 className='fs-8 my-3'>Update Data</h5>
                                <NodeUpdates config={row?.update_data?.templates} />

                                <h5 className='fs-8 my-3'>Target Node</h5>
                                <InputFieldSwitch
                                    defaultValue={
                                        typeof row?.target_node === 'string' ? false : true
                                    }
                                    config={{ name: 'code_snippet', label: 'Code Snippet?' }}
                                    onChange={(value) => {
                                        handleUpdate(index, {
                                            code_snippet: value,
                                            target_node: value
                                                ? {
                                                      template: row?.target_node,
                                                      parser: 'mako',
                                                  }
                                                : row?.target_node?.template,
                                        });
                                    }}
                                />
                                <div className='my-3'>
                                    {typeof row?.target_node === 'string' && (
                                        <InputField
                                            defaultValue={row?.target_node}
                                            config={{
                                                placeholder: 'Target Node',
                                                name: 'target_node',
                                                className: 'form-control-xs',
                                            }}
                                            onChange={(value) =>
                                                handleUpdate(index, { target_node: value })
                                            }
                                        />
                                    )}
                                    {typeof row?.target_node !== 'string' && (
                                        <textarea
                                            className='form-control fs-8'
                                            defaultValue={row?.target_node?.template}
                                            placeholder='Target Node'
                                            name='target_node'
                                            rows={5}
                                            onChange={(e) =>
                                                handleUpdate(index, { target_node: e.target.value })
                                            }
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
            <div
                className='d-flex justify-content-center mt-5'
                onClick={handleAdd}>
                <button className='btn btn-sm btn-icon btn-circle btn-dark'>
                    <i className='bi bi-plus-lg'></i>
                </button>
            </div>
        </>
    );
};
export default NodeEdges;
